import './assets/scss/index.scss';
import './App.css';
import Router from "./components/Router";
import {ApplicationContextProvider} from "./types/contexts/ApplicationContext";
import {detectRequest} from "./hooks/detectRequest";
import {memo, useMemo} from 'react';
import {useDispatch} from "react-redux";
import {changeLanguage} from "./reducers/translations";
import {ENV} from "./pages/admin/Login";
import {createTheme, ThemeOptions, ThemeProvider} from "@mui/material";
import {defaultThemeOptions, mustHaveThemeOptions} from "./types/defaultThemeOptions";
import _ from "lodash";

export let isDarkMode = localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);
export const checkDarkMode = () => {
    isDarkMode = localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);
    if (isDarkMode) {
        document.documentElement.classList.add('dark');
    } else {
        document.documentElement.classList.remove('dark')
    }
}
const App = () => {

    const request = detectRequest(window.location.search || '');
    const dispatch = useDispatch();
    const theme = useMemo(() => {
        const data = _.merge({}, defaultThemeOptions, mustHaveThemeOptions) as ThemeOptions;
        return createTheme(
            _.merge({}, data as ThemeOptions)
        );
    }, []);
    if (!request) {
        throw Error('Unable to detect request')
    }

    if (request.theme === 'dark' || isDarkMode) {
        localStorage.setItem('color-theme', 'dark');
        document.documentElement.classList.add('dark');
    } else {
        localStorage.setItem('color-theme', 'light');
        document.documentElement.classList.remove('dark')
    }

    dispatch(changeLanguage(request.lang));

    return useMemo(() => {
        const env = process.env as unknown as ENV;
        document.body.classList.add(env.REACT_APP_LOGO);
        return (
            <ThemeProvider theme={theme} disableTransitionOnChange>
                <ApplicationContextProvider request={request}>
                    <aside className='sidebar'/>
                    <section>
                        <header/>
                        <main>
                            <Router/>
                        </main>
                        <footer/>
                    </section>
                </ApplicationContextProvider>
            </ThemeProvider>
        )
    }, [request, theme]);
}

export default memo(App);
